var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticStyle:{"width":"100%","height":"99px"}}),_c('router-view',{on:{"subPageTap":_vm.backToIndex}}),_c('Layout',{ref:"layout",attrs:{"topOrBottom":'bottom'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }